
/*
 * Formata os gêneros vindos do endpoint para o q-select do quasar
 * Com label e value
*/
export const formatGendersForQSelectQuasar = (genders) => {
  return genders.map((gender) => ({
    label: gender.title,
    value: gender.gender_id,
  }));
};